import { z } from 'zod';
/** Host → AIRA iframe postMessage payload (Sharefox Admin embed). */
export const SharefoxIframeAuthMessageSchema = z.object({
    siteName: z.string().min(1),
    userToken: z.string().min(1),
    userEmail: z.string().email(),
    firstName: z.string(),
    lastName: z.string(),
    appLanguage: z.string().optional(),
    path: z.string().optional(),
});
/** Child → host readiness handshake. */
export const SharefoxChildReadyMessageSchema = z.object({
    type: z.literal('sf_child_ready'),
});
export const SiteNameSchema = z
    .string()
    .min(1)
    .max(63)
    .regex(/^[a-z0-9_-]+$/i, 'site_name must be alphanumeric, underscore, or dash');
export const SharefoxAdminExchangeRequestSchema = z.object({
    site_name: SiteNameSchema,
    admin_token: z.string().min(1),
    user_email: z.string().email().optional(),
    first_name: z.string().optional(),
    last_name: z.string().optional(),
});
const SharefoxAdminExchangeResponseBaseSchema = z.object({
    tenant_name: z.string(),
    pending_site: SiteNameSchema.optional(),
    /** False when the Sharefox Site tenant has not been activated yet (user must visit `/activate`). */
    activated: z.boolean(),
});
/** Production (firebase AUTH_MODE) — Identity Platform custom token. */
const SharefoxAdminExchangeFirebaseResponseSchema = SharefoxAdminExchangeResponseBaseSchema.extend({
    custom_token: z.string(),
});
/** Local (supabase-local AUTH_MODE) — GoTrue session for `auth.setSession()`. */
const SharefoxAdminExchangeSupabaseResponseSchema = SharefoxAdminExchangeResponseBaseSchema.extend({
    access_token: z.string(),
    refresh_token: z.string(),
});
export const SharefoxAdminExchangeResponseSchema = z.union([
    SharefoxAdminExchangeFirebaseResponseSchema,
    SharefoxAdminExchangeSupabaseResponseSchema,
]);
export const SharefoxAdminUserInfoSchema = z.object({
    id: z.number().int().positive(),
    email: z.string().email(),
    firstName: z.string(),
    lastName: z.string(),
});
//# sourceMappingURL=sharefox-admin-auth.js.map